import { render, staticRenderFns } from "./levelAdmin.vue?vue&type=template&id=6424bb0c&"
import script from "./levelAdmin.vue?vue&type=script&lang=js&"
export * from "./levelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./levelAdmin.vue?vue&type=style&index=0&id=6424bb0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports